export default __webpack_public_path__ + "static/media/ruined_wasp_nest.bc2b68a7.png";